import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import founderImage from '../../assets/instasize_241220124733.png'; // Add your image path here

const AboutUsPage = () => {
  // Initialize AOS on component mount
  useEffect(() => {
    AOS.init({
      duration: 1000,  // Animation duration in ms
      once: true,      // Animation happens once
    });
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <Container>
        {/* About Us Section */}
        <Row className="mb-5">
          <Col data-aos="fade-up">
            <h1 className="text-center mb-4">About Us</h1>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
              Shivek Group is a diversified conglomerate offering a wide range of high-quality
              services across multiple industries, including logistics, food, e-commerce, travel,
              real estate, and business solutions. With a commitment to excellence, innovation, and
              customer satisfaction, we provide tailored solutions to meet the unique needs of our
              clients.
            </p>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
              Founded with a vision to deliver reliable, efficient, and cost-effective services, Shivek
              Group has grown to become a trusted partner in each of its sectors. From providing
              cutting-edge logistics solutions and delicious food experiences to offering reliable
              travel services, real estate development, and expert business consultancy, our
              dedication to quality and customer-first approach has been the cornerstone of our success.
            </p>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
              At Shivek Group, we believe in fostering long-term relationships and helping
              businesses and individuals achieve their goals through our diverse expertise and
              comprehensive services.
            </p>
          </Col>
        </Row>

        {/* Founders Section */}
        
        <Row className="mb-5">
          <Col data-aos="fade-up">
            <h2 className="text-center mb-4">Our Founder</h2>
            <Row className="justify-content-center">
          <Col md={4} className="text-center" data-aos="fade-up">
            <Card>
              <Card.Body className='d-flex flex-column align-items-center justify-content-center text-center'>
                <Image
                  src={founderImage}
                  alt="Vivek Sen"
                  roundedCircle
                  style={{ width: '50%', height: 'auto', marginBottom: '1rem' }}
                />
                <h3 className="text-center">Vivek Sen</h3>
                <p className="text-center">Founder and CEO</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
            <p className="text-center" style={{ fontSize: '1.2rem', lineHeight: '1.6', marginTop:'2rem' }}>
              <strong>Vivek Sen</strong>, Founder and CEO of Shivek Group, has over 8+ years of experience in
              the logistics industry, with a deep expertise in managing complex operations. Specializing in
              manpower supply and operational coordination, he has successfully provided services such as field
              executives, team leaders, area managers, and vehicle arrangements for large-scale logistics operations.
            </p>
            <p className="text-center" style={{ fontSize: '1.2rem', lineHeight: '1.6' }}>
              Vivek’s extensive experience also includes working with External Delivery Service Providers (EDSP),
              ensuring smooth and efficient delivery operations across regions.
            </p>
            <p className="text-center" style={{ fontSize: '1.2rem', lineHeight: '1.6' }}>
              Beginning his career with a focus on optimizing workforce deployment and resource management, Vivek’s
              strategic planning and attention to detail have helped place the right talent in the right roles,
              driving performance and timely deliveries. His work with external providers has enabled companies to
              expand their reach and improve delivery timelines, offering exceptional service to clients.
            </p>
          </Col>
        </Row>

        {/* Founder Image */}
        
      </Container>
    </div>
  );
};

export default AboutUsPage;
